import React, { useState, FC } from 'react';
import { Box } from '@mui/material';

import { Day } from './day';
import { Week } from './week';
import { Month } from './month';
import { Listing } from './table';
import { CalendarView } from '../types';
import { CalendarPanel } from './CalendarPanel';
import { CalendarLayout } from './CalendarLayout';

export const CalendarContainer = () => {
  const [view, setView] = useState<CalendarView>(CalendarView.Table);

  const renderNestedSectionByMode: Record<CalendarView, FC<any>> = {
    [CalendarView.Day]: Day,
    [CalendarView.Week]: Week,
    [CalendarView.Month]: Month,
    [CalendarView.Table]: Listing,
  };

  const ViewComponent = renderNestedSectionByMode[view];

  return (
    <>
      <CalendarLayout>
        <CalendarPanel view={view} setView={setView} />

        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <ViewComponent />
        </Box>
      </CalendarLayout>
    </>
  );
};
